import { Skeleton, Stack } from "@mui/material";

export default function TeamReportSkeleton({
  isOwnershipReport,
}: {
  isOwnershipReport?: boolean;
}) {
  return (
    <Stack direction="row">
      {!isOwnershipReport && (
        <Stack
          sx={{
            width: 280,
            flexShrink: 0,
            pt: 4,
            pl: 2,
            pr: 6,
          }}
          spacing={3}
        >
          <Skeleton variant="rounded" width="70%" height={20} />
          <Skeleton variant="rounded" width="100%" height={20} />
          <Skeleton variant="rounded" width="100%" height={20} />
          <Skeleton variant="rounded" width="100%" height={20} />
          <Skeleton variant="rounded" width="100%" height={20} />
          <Skeleton variant="rounded" width="100%" height={20} />
        </Stack>
      )}
      <Stack
        sx={{
          flex: 1,
          px: 2,
          pt: 4,
          pb: 12,
        }}
        spacing={4}
      >
        <Stack direction="row" justifyContent="space-between">
          <Skeleton variant="rounded" width={300} height={120} />
          <Skeleton variant="rounded" width={200} height={80} />
        </Stack>

        <Stack direction="row" justifyContent="space-between">
          <Skeleton variant="rounded" width={200} height={40} />
          <Skeleton variant="rounded" width={300} height={20} />
        </Stack>

        {isOwnershipReport && (
          <>
            <Skeleton variant="text" width={250} height={50} />
            <Skeleton variant="rounded" width="100%" height={70} />
          </>
        )}

        <Skeleton variant="text" width={250} height={50} />
        <Skeleton variant="rounded" width="100%" height={100} />
        <Skeleton variant="rounded" width="100%" height={200} />

        {!isOwnershipReport ? (
          <>
            <Skeleton variant="text" width={250} height={50} />
            <Stack direction="row" justifyContent="space-between">
              {[1, 2, 3, 4, 5].map((index) => (
                <Skeleton
                  key={index}
                  variant="rounded"
                  width={180}
                  height={150}
                />
              ))}
            </Stack>
          </>
        ) : (
          <>
            <Skeleton variant="rounded" width="100%" height={100} />
            <Skeleton variant="rounded" width="100%" height={200} />
          </>
        )}

        <Skeleton variant="text" width={250} height={50} />
        <Skeleton variant="rounded" width="100%" height={300} />
      </Stack>
    </Stack>
  );
}
